import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderSlot as _renderSlot, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
    key: 3,
    type: "button",
    class: "btn _waiting"
};
const _hoisted_6 = {
    key: 4,
    type: "button",
    class: "btn _removing"
};
const _hoisted_7 = {
    key: 0,
    class: "imageDropSpace"
};
const _hoisted_8 = { class: "dragSpace" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_placeholder_img = _resolveComponent("placeholder-img");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", {
            class: "_allegatiContainer",
            onDragover: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["prevent"])),
            onDrop: _cache[1] || (_cache[1] = _withModifiers(
            //@ts-ignore
            (...args) => (_ctx.dropImage && _ctx.dropImage(...args)), ["prevent"]))
        }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previews, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["_allegato", { 'disabled': item.toRemove }]),
                    key: i
                }, [
                    _createVNode(_component_placeholder_img, {
                        class: "_allegatoPreview",
                        source: item.publicUrl
                    }, null, 8, ["source"]),
                    _createElementVNode("button", {
                        type: "button",
                        class: "btn _gallery",
                        onClick: ($event) => (_ctx.gallery(i))
                    }, _cache[6] || (_cache[6] = [
                        _createElementVNode("i", { class: "fas fa-search" }, null, -1)
                    ]), 8, _hoisted_1),
                    (!_ctx.readonly)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn _remove",
                            onClick: ($event) => (_ctx.remove(item, i))
                        }, " X ", 8, _hoisted_2))
                        : _createCommentVNode("", true),
                    (_ctx.showForceRemove)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn _remove _force",
                            onClick: ($event) => (_ctx.forceRemove(item, i))
                        }, " XXX ", 8, _hoisted_3))
                        : _createCommentVNode("", true),
                    (!item.fileToUpload && !item.toRemove)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            class: "btn _download",
                            onClick: ($event) => (_ctx.download(item))
                        }, " Download ", 8, _hoisted_4))
                        : _createCommentVNode("", true),
                    (item.fileToUpload)
                        ? (_openBlock(), _createElementBlock("button", _hoisted_5, " Da caricare "))
                        : _createCommentVNode("", true),
                    (item.toRemove)
                        ? (_openBlock(), _createElementBlock("button", _hoisted_6, " Da eliminare "))
                        : _createCommentVNode("", true)
                ], 2));
            }), 128))
        ], 32),
        (!_ctx.readonly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", {
                    class: "drag-drop",
                    onDragover: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["prevent"])),
                    onDrop: _cache[4] || (_cache[4] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.dropImage && _ctx.dropImage(...args)), ["prevent"])),
                    onClick: _cache[5] || (_cache[5] =
                        //@ts-ignore
                        (...args) => (_ctx.click && _ctx.click(...args)))
                }, [
                    _createElementVNode("span", _hoisted_8, [
                        _renderSlot(_ctx.$slots, "default", {}, () => [
                            _cache[7] || (_cache[7] = _createTextVNode("Trascina allegati ")),
                            _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                            _cache[9] || (_cache[9] = _createTextVNode(" o clicca qui"))
                        ], true)
                    ]),
                    _createElementVNode("input", {
                        type: "file",
                        onChange: _cache[2] || (_cache[2] =
                            //@ts-ignore
                            (...args) => (_ctx.onFileSelect && _ctx.onFileSelect(...args))),
                        ref: "fileInput",
                        multiple: "",
                        class: "hidden absolute"
                    }, null, 544)
                ], 32)
            ]))
            : _createCommentVNode("", true)
    ]));
}
